__turbopack_context__.v({
  "modal": "modals-module-scss-module__sO45Nq__modal",
  "modal-address": "modals-module-scss-module__sO45Nq__modal-address",
  "modal-client": "modals-module-scss-module__sO45Nq__modal-client",
  "modal-email-address": "modals-module-scss-module__sO45Nq__modal-email-address",
});
